var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6386 6.66699C15.6386 10.2014 11.794 13.3535 9.92847 14.6749C9.32849 15.0999 8.54422 15.0999 7.94424 14.6749C6.0787 13.3535 2.23409 10.2014 2.23409 6.66699C2.23409 5.07569 2.94022 3.54957 4.19713 2.42435C5.45405 1.29913 7.1588 0.666992 8.93636 0.666992C10.7139 0.666992 12.4187 1.29913 13.6756 2.42435C14.9325 3.54957 15.6386 5.07569 15.6386 6.66699Z",
    fill: "#716E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93636 8.66699C10.1702 8.66699 11.1705 7.77156 11.1705 6.66699C11.1705 5.56242 10.1702 4.66699 8.93636 4.66699C7.70251 4.66699 6.70227 5.56242 6.70227 6.66699C6.70227 7.77156 7.70251 8.66699 8.93636 8.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.78f2fc9feddc3b757dd5db1f7a890a0a.svg";
export { ForwardRef as ReactComponent };